import React from 'react';
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker,
} from "react-google-maps";
import {Card} from 'antd';

const MapWithAMarker = withScriptjs(withGoogleMap(({lat, lng}) =>
    <GoogleMap
        defaultZoom={15}
        center={{lat, lng}}
    >
        <Marker
            position={{lat, lng}}
        />
    </GoogleMap>
));

const Loading = () => (
    <Card loading={true} style={{height: '100%'}}/>
);

const Map = (props) => (
    <MapWithAMarker
        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDy-YHrezBqqRqaAZj2JFUAzvBVPzfMHCc&v=3.exp&libraries=geometry,drawing,places"
        loadingElement={<Loading/>}
        containerElement={<div style={{ height: '300px' }} />}
        mapElement={<div style={{ height: '100%' }} />}
        {...props}
    />
);

export default Map;


// WEBPACK FOOTER //
// ./resources/assets/js/components/Map.js